/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { FRUser, HttpClient } from '@forgerock/javascript-sdk';
import { HttpClientRequestOptions } from '@forgerock/javascript-sdk/lib/http-client';
import { Navigate } from 'react-router-dom';
import { configOptions, idmConfigOptions as idmConfig } from '../config';
import { useAppDispatch } from '../redux/hooks';
const apiRequest = async (baseUrl: string,

  _init: HttpClientRequestOptions['init'],
  resource: string,
  method: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any) => {
  let json;

  //  sanatize the backslash out
  if (baseUrl.slice(baseUrl.length-1) === '/') {
    baseUrl = baseUrl.slice(0,baseUrl.length-1);
  }
  if (resource.slice(0,1) === '/') {
    resource = resource.slice(1,resource.length);
  }

  try {
    //  mix in the init that is passed in
    const response = await HttpClient.request({
      url: `${baseUrl}/${resource}`,
      init: {...{
        body: data && JSON.stringify(data),
        headers: { 'Content-Type': 'application/json'},
        method: method
      }, ..._init},
      timeout: 60000
    });
    if (!response.ok) {
      let errorData :any
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        // Parse JSON response for error details
        errorData = await response.json();
      }
      if(response.status===401){
       window.location.reload();
      }
      throw new Error(errorData?.detail?.description ? `Status ${response.status}: API request failed. Details: ${errorData.detail.description}`:`Status ${response.status}: API request failed.`);
    }
    json = await response.json();
  } catch (err) {
    console.error(`Error: API request; ${err}`);

    json = {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      error: (err as any).message,
    };
  }
  return json;
};

const idmRequest =  (resource: string, method: string, data?: unknown) => {
  return apiRequest(idmConfig.baseUrl,{},resource,method,data);
};

export const amRequest = (url:string,data?:unknown) =>{
  return apiRequest(configOptions.serverConfig.baseUrl,{},url,'GET',data)
}

export default idmRequest;

